import { render, staticRenderFns } from "./alt-pagination.vue?vue&type=template&id=a34ebe20&"
import script from "./alt-pagination.vue?vue&type=script&lang=ts&"
export * from "./alt-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./alt-pagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports